
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.9886 11.3059V9.30996C14.9886 9.04529 14.8835 8.79146 14.6964 8.6043C14.5092 8.41715 14.2554 8.31201 13.9908 8.31201H4.51149C4.24685 8.31201 3.99305 8.41715 3.80593 8.6043C3.6188 8.79146 3.51367 9.04529 3.51367 9.30996V16.2956C3.51367 16.5603 3.6188 16.8141 3.80593 17.0012C3.99305 17.1884 4.24685 17.2935 4.51149 17.2935H13.9908C14.2554 17.2935 14.5092 17.1884 14.6964 17.0012C14.8835 16.8141 14.9886 16.5603 14.9886 16.2956V13.8007","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.84668 5.81706L12.5043 4.3401C12.5679 4.32219 12.6344 4.31734 12.6999 4.32586C12.7654 4.33437 12.8285 4.35607 12.8854 4.38965C12.9423 4.42322 12.9918 4.46797 13.0309 4.52121C13.07 4.57444 13.0979 4.63504 13.113 4.69936L13.3924 5.81706","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.9866 11.3057H13.4921C13.2165 11.3057 12.9932 11.5291 12.9932 11.8046V13.3016C12.9932 13.5771 13.2165 13.8005 13.4921 13.8005H15.9866C16.2622 13.8005 16.4855 13.5771 16.4855 13.3016V11.8046C16.4855 11.5291 16.2622 11.3057 15.9866 11.3057Z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    